import React from 'react';
import PropTypes from 'prop-types'
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import s from './Search.css';
import * as actions from '../../actions/search';
import noResult from './noResult.png'
import Layout from '../../components/global/Layout';
import CourseCard from '../../components/common/CourseCard'
import LoadMore from '../../components/common/LoadMore';
import { trackEventLog } from '../../core/utils'

class Search extends React.Component {

  constructor(props) {
    super(props)
    this.loadMore = this.loadMore.bind(this)
  }

  loadMore() {
    const { searchItem, searchResult, fetchSearchMore } = this.props
    return fetchSearchMore(searchItem, searchResult.courses.length)
  }

  render() {
    const { searchItem, searchResult, isSearching, searchResultHasMore } = this.props
    const { courses } = searchResult
    if (isSearching) {
      return (
        <Layout>
          <div className={s.searching}>拼命搜索中...</div>
        </Layout>
      )
    }

    if (!courses || !courses.length) {
      return (
        <Layout>
          <img src={noResult} className={s.noresultImg} alt={'无结果'} />
          <div className={s.noresult}>
            共搜索到0门&nbsp;
            <span className={s.item}>{searchItem}</span>
            &nbsp;有关课程
          </div>
        </Layout>
      )
    }
    return (
      <Layout>
        {courses.length ?
          <div className={s.courseResult}>
            <div className={s.result}>
              <span>以下是有关&nbsp;</span>
              <span className={s.item}>{searchItem}</span>
              &nbsp;的全部课程
            </div>
            <div>
              {courses.map((course, idx) => (
                <CourseCard
                  inLoc={'seaReslt'}
                  key={`search_course_${idx}`} // eslint-disable-line
                  data={course}
                  onClick={() => { trackEventLog('w/search') }}
                />
              ))}
            </div>
            <LoadMore onReachBottom={this.loadMore} hasMore={searchResultHasMore} />
          </div> : null}
      </Layout>
    );
  }
}

Search.propTypes = {
  searchResult: PropTypes.shape({
    courses: PropTypes.array.isRequired,
    teacher: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
    }),
  }).isRequired,
  isSearching: PropTypes.string.isRequired,
  searchItem: PropTypes.string.isRequired,
  fetchSearchMore: PropTypes.func.isRequired,
  searchResultHasMore: PropTypes.bool.isRequired,
};

function mapStateToProps(state) {
  return {
    isSearching: state.search.isSearching,
    searchItem: state.search.searchItem,
    searchResult: state.search.searchResult,
    searchResultHasMore: state.search.searchResultHasMore,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actions, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(s)(Search));



// WEBPACK FOOTER //
// ./src/routes/search/Search.js